module.exports = __webpack_public_path__ + "img/products-1.c5486b9.webp";